<div
	id="buscador"
	class="mobile"
	class="mobile abajo abajoBoton16"
	[ngClass]="{ abajo: esBotonComprarAbajo(), abajoBoton16: esCiudadHuaraz() }"
>
	<button
		id="btn-clic-open-box-buscador-mobile"
		(click)="togglePopup()"
		class="border-none rounded-none w-full h-[40px] font-ubuntu text-f17 font-bold text-center flex justify-center items-center"
		[ngClass]="{
			rojo: esCiudadRoja(),
			botonNaranjaRedondo: esCiudadHuaraz(),
		}"
	>
		<span>Compra tu pasaje aquí</span>
		<span class="material-icons">
			@if(esBotonComprarAbajo()){
			{{ isOpen() ? 'expand_more' : 'expand_less' }}
			}
			<!--ididid-->
			@else {
			{{ isOpen() ? 'expand_less' : 'expand_more' }}
			}
		</span>
	</button>
	<div
		id="dropdownContentBucadorMobile"
		[class.visible_]="isOpen()"
		[class.hidden_]="!isOpen()"
		[class.abrirArriba]="esBotonComprarAbajo()"
		[class.left15YPosicion]="esCiudadHuaraz()"
		class="absolute top-full left-0 w-full px-[20px] transition-all"
	>
		<div class="bg-white border shadow-lg p-4 w-full m-auto rounded-ss-0 rounded-b-[20px]">
			<app-formulario-buscador [codigoEcommerceVuelta]="codigoEcommerceVuelta" />
		</div>
	</div>
	<!-- <mat-accordion>
		<mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
			<mat-expansion-panel-header>
				<mat-panel-title> Compra tu pasaje aquí </mat-panel-title>
			</mat-expansion-panel-header>
			<app-formulario-buscador />
		</mat-expansion-panel>
	</mat-accordion> -->
</div>
<div [class.visible_]="isOpen()" [class.hidden_]="!isOpen()" id="dropdownContentBucadorMobile2"></div>
